import React from "react";
import { withStyles } from "material-ui/styles";

const styles = () => ({
  ul: {
    listStyle: "none",
    padding: "5px 10px",
    margin: 0,
    border: "1px solid",
    borderColor: "#80AA24", // theme.palette.error[700],
    color: "#60860C", // theme.palette.error[700],
    background: "#F6FEE5", // theme.palette.error[50],
    borderRadius: 3
  }
});

const Message = props => {
  const canShow = props.messages && props.messages.length > 0;

  return canShow ? (
    <div className={props.className}>
      <ul className={props.classes.ul}>
        {props.messages.map(message => <li key={message}>{message}</li>)}
      </ul>
    </div>
  ) : null;
};

export default withStyles(styles)(Message);



// WEBPACK FOOTER //
// ./src/components/Message.jsx